<template>
    <div class="home">
        <MbLoading v-if="isLoading"></MbLoading>
        <div v-else>
            <div class="content-overlay"></div>
            <section class="board container-fluid">
                <div v-if="page && !page.hideTitle" class="page-header margin-top-md mobile-margin-top-0">{{page.name}}</div>
            </section>

            <section class="board container-fluid">
                <div v-if="page.confirmPageText" v-html="page.confirmPageText"></div>
                <div v-else class="row">
                    <div class="col-sm-12">
                        <p>Grazie per la richiesta di iscrizione.</p>
                        <p>Controllare la propria email per completare la registrazione.</p>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4 offset-sm-4">
                        <button @click="onClickCta()" id="my-submit" class="go-to-cart-button button red-button button-full" type="button">
                            <template v-if="page.confirmPageCtaText">{{ page.confirmPageCtaText }}</template>
                            <template v-else>Torna alla home</template>                            
                        </button>
                    </div>
                </div>
            </section>
        </div>
        <MbScriptField :value="page.confirmPageScript"></MbScriptField>
    </div>
</template>

<script>
import MediaLibraryAPI from "@/service/MediaLibraryAPI"
import MbPageService from './MbPageService'
import MbLoading from "@/components/newsletter_form/MbLoading"
import MbScriptField from "@/components/newsletter_form/MbScriptField"

export default {
    components: {
        MbLoading,
        MbScriptField
    },
    data() {
        return {
            isLoading: true,
            page: {}
        }
    },
    mounted() {
        let pagePermalink = this.$route.params.pagePermalink
        if (!pagePermalink || pagePermalink == null) {
            this.$router.push("/page-not-found")
            return
        }

        if (this.$route.query.preview) {
            this.loadPrevie()
            return
        }
        
        this.page = MbPageService.page
        if (this.page == null) {
            this.$router.replace("/iscrizioni/" + pagePermalink)
            return
        }
        this.isLoading = false
    },
    methods: {
        loadPrevie() {
            let pagePermalink = this.$route.params.pagePermalink
            MediaLibraryAPI.getPage(pagePermalink)
                .then(({ data }) => {
                    if (!data) {
                        this.$router.push("/page-not-found")
                        return
                    }

                    this.page = data.data
                    if (!this.page) {
                        this.$router.push("/page-not-found")
                        return
                    }

                    if (this.page.pageId != this.$route.query.id) {
                        this.$router.push("/page-not-found")
                        return
                    }

                    if (data.hasErrors) {
                        this.pageErrors = data.errors
                        this.isLoading = false
                        return
                    }

                    MbPageService.setPage(this.page)
                    this.isLoading = false
                }).catch((errors) => {
                    this.pageErrors.push(errors)
                    this.isLoading = false
                })
        },
        onClickCta() {
            if (this.page.confirmPageCtaUrl) {
                window.location.href = this.page.confirmPageCtaUrl
                return
            }

            window.location.href = "https://www.erickson.it"
        }
    }
}
</script>

<style>

</style>
